import { LitElement, html, css, unsafeCSS, render } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { RDPropsetContainer } from "../Container/PropContainer.js";

import styles from "./button.css?raw";

export class propButton extends RDPropsetContainer {
  static styles = [
    super.styles,
    css`
      ${unsafeCSS(styles)}
    `,
  ];
  static properties = {
    value: { type: String },
    disabled: { type: Boolean, reflect: true },
    variant: { type: String, reflect: true },
    sizeType: { type: String, reflect: true },
    callback: { type: Function },
    onClick: { type: Function },
    radius: { type: String, reflect: true },
  };
  constructor() {
    super();
    this.value = "Button";
    this.disabled = false;
    this.variant = "primary"; // primary, secondary, success, danger, warning, info, outline
    this.sizeType = "medium"; // small, medium, large
    this.callback = null;
    this.onClick = null;
    this.radius = "6px";

    // Disable devices and themes for button component
    this.isDevices = false;
    this.isThemes = false;
  }
  firstUpdated() {
    super.firstUpdated();
  }
  updated(changedProperties) {
    super.updated(changedProperties);
  }
  _onClick(e) {
    if (this.onClick && typeof this.onClick === "function") {
      this.onClick.bind(this)(this.value);
    }
    if (this.callback && typeof this.callback === "function") {
      this.callback.bind(this)(this.value);
    }
    this.dispatchEvent(new CustomEvent("prop-clicked", { detail: { value: this.value } }));
  }
  _renderButtonValue() {
    render(html`<span> ${unsafeHTML(this.value)} </span>`, this);
    return "";
  }
  _renderButton() {
    const buttonClasses = `rd-btn rd-btn-${this.variant} rd-btn-${this.sizeType}`;
    return html`
      <div class="rd-prop-button-input" style="">
        <button class="${buttonClasses}" style="--rd-btn-radius: ${this.radius};" .disabled="${this.disabled || this._partialDisabled}" @click="${this._onClick}"><slot>${this._renderButtonValue()}</slot></button>
      </div>
    `;
  }
  renderBody() {
    return html`<div class="rd-prop-button-container" tabindex="-1">${this._renderButton()}</div>`;
  }
}
if (!customElements.get("rd-prop-button")) {
  customElements.define("rd-prop-button", propButton);
}
